'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _trip = require('redux/modules/trip');

var _payment = require('redux/modules/payment');

var _reactRouterRedux = require('react-router-redux');

var _DefaultTrip = require('./DefaultTrip');

var _DefaultTrip2 = _interopRequireDefault(_DefaultTrip);

var _ZHTrip = require('./ZHTrip');

var _ZHTrip2 = _interopRequireDefault(_ZHTrip);

var _SharedTrip = require('./SharedTrip');

var _SharedTrip2 = _interopRequireDefault(_SharedTrip);

var _PrivateGuideTrip = require('./PrivateGuideTrip');

var _PrivateGuideTrip2 = _interopRequireDefault(_PrivateGuideTrip);

var _helpers = require('utils/helpers');

var _price = require('utils/price');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Trip: {
    displayName: 'Trip'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/Trip.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Trip = _wrapComponent('Trip')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
    omitBookingFee: state.info.userConfig.omitBookingFee,
    siteConfigs: state.info.siteConfigs,
    tripBookNow: state.info.userConfig.tripBookNow
  };
}, (0, _extends3.default)({}, sessionActions, { openExternal: _trip.openExternal, clickTrip: _trip.clickTrip, impressTrip: _trip.impressTrip, loadTripDetail: _trip.load, setPaymentData: _payment.setPaymentData, push: _reactRouterRedux.push, logClickBookNow: _trip.logClickBookNow })), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Trip, _Component);

  function Trip(props) {
    (0, _classCallCheck3.default)(this, Trip);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Trip.__proto__ || (0, _getPrototypeOf2.default)(Trip)).call(this, props));

    _this.impress = _this.impress.bind(_this);

    if (!(typeof _this.impress === 'function')) {
      throw new TypeError('Value of "this.impress" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.impress));
    }

    _this.click = _this.click.bind(_this);

    if (!(typeof _this.click === 'function')) {
      throw new TypeError('Value of "this.click" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.click));
    }

    _this.requestBook = _this.requestBook.bind(_this);

    if (!(typeof _this.requestBook === 'function')) {
      throw new TypeError('Value of "this.requestBook" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.requestBook));
    }

    return _this;
  }

  (0, _createClass3.default)(Trip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        var rect = _this2.refs.root.getBoundingClientRect();
        var elemCenter = (rect.top + rect.bottom * 2) / 3;
        if (elemCenter <= window.innerHeight && rect.bottom >= 60) {
          _this2.impress();
        }
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: 'getQuantity',
    value: function getQuantity(maxTravelers) {
      return this.props.sessionData.quantity > maxTravelers ? maxTravelers : this.props.sessionData.quantity;
    }
  }, {
    key: 'impress',
    value: function impress() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.props.impressTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
      }
    }
  }, {
    key: 'click',
    value: function click() {
      this.props.clickTrip(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
      this.impress();
      if (this.props.trip.is_external) {
        this.props.openExternal(this.props.trip.external_url);
      }
    }
  }, {
    key: 'requestBook',
    value: function requestBook() {
      this.props.logClickBookNow(this.props.trip._id, this.props.searchSessionId, this.props.trip.ranking_algorithm, this.props.index);
      this.props.push('/booking/new?trip=' + this.props.trip.slug + '&device=bookNow&requestType=book');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          trip = _props.trip,
          sessionData = _props.sessionData,
          rates = _props.rates,
          omitBookingFee = _props.omitBookingFee,
          type = _props.type,
          tripBookNow = _props.tripBookNow;
      var quantity = sessionData.quantity,
          currency = sessionData.currency;

      var thumbnailCurrency = this.props.currency;
      var displayPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
      var displaySeasonedPrice = (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplaySeasonedPrice)(quantity, trip.full_prices, omitBookingFee), thumbnailCurrency || currency, rates));
      return _react3.default.createElement(
        'div',
        { ref: 'root', onClick: this.click },
        function () {
          switch (type) {
            case 'tour_shared':
              return _react3.default.createElement(_SharedTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
            case 'tour_private':
              return _react3.default.createElement(_PrivateGuideTrip2.default, { trip: trip, prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency });
            case 'zh':
              return _react3.default.createElement(_ZHTrip2.default, { trip: trip, prices: { displayPrice: displayPrice } });
            default:
              return _react3.default.createElement(_DefaultTrip2.default, (0, _extends3.default)({}, _this3.props, { prices: { displayPrice: displayPrice, displaySeasonedPrice: displaySeasonedPrice }, currency: currency, thumbnailCurrency: thumbnailCurrency, tripBookNow: tripBookNow, requestBook: _this3.requestBook }));
          }
        }()
      );
    }
  }]);
  return Trip;
}(_react2.Component), _class2.propTypes = {
  tripBookNow: _react2.PropTypes.bool,
  omitBookingFee: _react2.PropTypes.bool,
  index: _react2.PropTypes.number,
  type: _react2.PropTypes.string,
  from: _react2.PropTypes.string,
  target: _react2.PropTypes.string,
  currency: _react2.PropTypes.string,
  searchSessionId: _react2.PropTypes.string,
  trip: _react2.PropTypes.object,
  rates: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  isWishlisted: _react2.PropTypes.object,
  push: _react2.PropTypes.func,
  clickTrip: _react2.PropTypes.func,
  impressTrip: _react2.PropTypes.func,
  openExternal: _react2.PropTypes.func,
  loadTripDetail: _react2.PropTypes.func,
  setPaymentData: _react2.PropTypes.func,
  logClickBookNow: _react2.PropTypes.func
}, _class2.defaultProps = {
  target: null,
  searchSessionId: null
}, _temp)) || _class));

exports.default = Trip;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Trip/Trip.js
// module id = 112
// module chunks = 1 2 9 13 14 24